import { AiRecommendation } from "./types";

export const AI_CHAT_FREE_SHOW_ONLY = true;
export const AI_CHAT_COOKIE_ENABLED = "ai_chat_user_enabled";
export const AI_CHAT_COOKIE_POSITION = "ai_chat_recommendation_position";

export const InitialData = {
  aiRecommendations: [] as AiRecommendation[],
  isProcessingQueue: false,
};
